<template>
	<div>
		<div class="p_m_b_20" v-for="(item,index) in count">
			<div class="p_flex">
				<el-tag type="success" size="small " effect="dark">{{item.question.question_type==1?"单选题":item.question.question_type==2?"多选题":item.question.question_type==3?"判断题":item.question.question_type==4?"填空题":item.question.question_type==5?"问答题":"材料题"}}</el-tag>
				<span class="type_size_22 p_m_l_20" v-html="item.question.title"></span>
			</div>
			<span class="p_flex p_m_t_20 type_size_18" v-for="(ietm,index) in item.content" v-show="item.image.length != 0 ? false : true">{{index+1}}.{{ietm.text}}</span>
			<div class="deatil_img p_m_t_20" v-for="(teim,index) in item.image">
				<!-- <img :src="teim"> -->
				<el-image style="width: 100%; height:auto;margin-top: 30px;" v-for="(teim, index) in  item.image" :key="index" :src="teim" :preview-src-list=" item.image"></el-image>
			</div>
			<span class="p_flex p_m_t_20 type_size_22 subject_color p_f_e">{{item.result==1?"正确":item.result==2?"错误":"待批改"}}</span>
		</div>
		<pagination @get="get" :index="num"/>
	</div>
</template>

<script>
import pagination from '../../../pagination/pagination.vue'
export default {
	data() {
		return {
			num:0,
			count: [],
		};
	},
	created() {
		// console.log(this.$route.query.id)   // 作业id
		// console.log(this.$route.query.ids) //学生id
		this.get()
	},
	components:{
		pagination
	},
	methods: {
		get(id){
			this.$request.ajax(this).post("/api_teacher/analysis_student_answer_detail",{
			job_publish_id:this.$route.query.id,
			student_id:this.$route.query.ids,
			limit:10,
			page:id?id:1
		}).then(res=>{
			// console.log(res)
			this.count=res.data.list
			this.num = res.data.count
		})
		}
	}
};
</script>

<style lang="scss" scoped>
>>> .el-tag--dark.el-tag--success {
	background-color: #00af63;
	border-color: #00af63;
}
.deatil_img{
	width: 300px;
	height: 450px;
}
.deatil_img img{
	width: 100%;
	height: 100%;
}


</style>



// WEBPACK FOOTER //
// src/components/homet/analyse/commponents/deatilslist.vue